import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import Slider from '../Slider';
import PlayProgressBar from './PlayProgressBar';
import LoadProgressBar from './LoadProgressBar';
import MouseTimeDisplay from './MouseTimeDisplay';
import PreviewThumbnail from './PreviewThumbnail';
import { formatTime } from '../../utils';
import Chapters from './Chapters';

const propTypes = {
  player: PropTypes.object,
  mouseTime: PropTypes.object,
  actions: PropTypes.object,
  className: PropTypes.string,
};

export default class SeekBar extends Component {

  constructor(props, context) {
    super(props, context);

    this.getPercent = this.getPercent.bind(this);
    this.getNewTime = this.getNewTime.bind(this);
    this.stepForward = this.stepForward.bind(this);
    this.stepBack = this.stepBack.bind(this);

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate() {
  }

  /**
   * Get percentage of video played
   *
   * @return {Number} Percentage played
   * @method getPercent
   */
  getPercent() {
    const { hasDVR, currentTime, seekingTime, duration, mediaDuration } = this.props.player;
    let percent;
    const time = seekingTime || currentTime;
    if (hasDVR) {
      percent = time / mediaDuration;
    } else {
      percent = time / duration;
    }
    return percent >= 1 ? 1 : percent;
  }

  getNewTime(event) {
    const { player: { hasDVR, duration, mediaDuration, playOffset } } = this.props;
    const distance = this.slider.calculateDistance(event);
    let _duration, newTime;
    if (hasDVR) {
      _duration = mediaDuration;
      newTime = distance * _duration + playOffset;
    } else {
      _duration = duration;
      newTime = distance * _duration;
    }

    // Don't let video end while scrubbing.
    return newTime === _duration ? newTime - 0.1 : newTime;
  }

  handleMouseDown() {
  }

  handleMouseUp(event) {
    const { actions } = this.props;
    const newTime = this.getNewTime(event);
    // Set new time (tell video to seek to new time)
    actions.seek(newTime);
    actions.handleEndSeeking(newTime);
  }

  handleMouseMove(event) {
    const { actions } = this.props;
    const newTime = this.getNewTime(event);
    actions.handleSeekingTime(newTime);
  }


  stepForward() {
    const { actions } = this.props;
    actions.forward(5);
  }

  stepBack() {
    const { actions } = this.props;
    actions.replay(5);
  }

  render() {
    const { actions,
      player,
      player:
          {
            latency,
            hasDVR,
            isLive,
            currentTime,
            seekingTime,
            duration,
            mediaDuration,
            playOffset,
            buffered
          },
      mouseTime,
      chapters,
      storyboard
    } = this.props;
    let _duration;
    const time = seekingTime || currentTime;
    if (hasDVR) {
      _duration = mediaDuration;
    } else {
      _duration = duration;
    }
    return (
      <Slider
        ref={(input) => {
          this.slider = input;
        }}
        label="video progress bar"
        className={classNames('video-react-progress-holder', this.props.className)}
        valuenow={(this.getPercent() * 100).toFixed(2)}
        valuetext={formatTime(time, _duration)}
        onMouseDown={this.handleMouseDown}
        onMouseMove={this.handleMouseMove}
        onMouseUp={this.handleMouseUp}
        getPercent={this.getPercent}
        stepForward={this.stepForward}
        stepBack={this.stepBack}
      >
        <LoadProgressBar
          buffered={buffered}
          playOffset={playOffset}
          hasDVR={hasDVR}
          currentTime={time}
          duration={_duration}
        />
        <MouseTimeDisplay
          duration={_duration}
          hasDVR={hasDVR}
          mouseTime={mouseTime}
        />
        <PreviewThumbnail
            duration={_duration}
            mouseTime={mouseTime}
            isLive={isLive}
            storyboard={storyboard}
            player={player}
        />
        <PlayProgressBar
          hasDVR={hasDVR}
          latency={latency}
          currentTime={time}
          duration={_duration}
        />
        <Chapters {...this.props} chapters={chapters} player={player} actions={actions}/>
      </Slider>
    );
  }
}

SeekBar.propTypes = propTypes;
SeekBar.displayName = 'SeekBar';
